<script setup lang="ts">
/**
 * Conversation header bar — ERP-style surface with title + actions.
 */
defineProps<{
  title?: string;
  subtitle?: string;
}>();
</script>

<template>
  <header class="nx-chat-header">
    <div class="nx-chat-header__left">
      <slot name="leading" />
      <div class="nx-chat-header__titles">
        <slot name="title">
          <h2 v-if="title" class="nx-chat-header__title">{{ title }}</h2>
        </slot>
        <slot name="subtitle">
          <p v-if="subtitle" class="nx-chat-header__subtitle">{{ subtitle }}</p>
        </slot>
      </div>
    </div>
    <div v-if="$slots.actions" class="nx-chat-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<style scoped>
.nx-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--nxt-space-sm);
  padding: var(--nxt-space-xs) calc(var(--nxt-space-md) * 1.125);
  min-height: var(--nxt-control-size-xl);
  box-sizing: border-box;
  background: var(--nxt-surface-bg);
  box-shadow: var(--nxt-shadow-sm);
  z-index: var(--nxt-z-above);
  flex: 0 0 auto;
}
.nx-chat-header__left {
  display: flex;
  align-items: center;
  gap: calc(var(--nxt-space-xs) * 1.25);
  min-width: 0;
  flex: 1 1 auto;
}
.nx-chat-header__titles {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: calc(
    var(--nxt-size-unit) * 0.0625
  ); /* stylelint-disable-line declaration-property-unit-disallowed-list -- 1px optical nudge */
}
.nx-chat-header__title {
  margin: 0;
  font-size: var(--nxt-font-size-md);
  font-weight: var(--nxt-font-weight-bold);
  letter-spacing: -0.015em;
  line-height: var(--nxt-line-height-tight);
  color: var(--nxt-fg);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nx-chat-header__subtitle {
  margin: 0;
  font-size: var(--nxt-font-size-xs);
  font-weight: var(--nxt-font-weight-medium);
  color: var(--nxt-fg-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nx-chat-header__actions {
  display: flex;
  align-items: center;
  gap: var(--nxt-space-2xs);
  flex: 0 0 auto;
}
</style>
